module.exports = __webpack_public_path__ + "img/laserbeam.97437a4f.jpg";